<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="page-sub-header">
        <div>
            <label class="page-header-title">Welcome!</label>
        </div>
        <div *ngIf="allMiniAppsDetails?.length > 0">
            <button type="button"  type="submit" fxLayoutAlign="center center" class="create-bot-btn" fxFlex
                [routerLink]="'/miniapps/create-miniapps'" [disabled]="!apiKeyIsGenerated">
                <mat-icon>add</mat-icon> Add new Mini App
            </button>
        </div>
    </div>
    <!-- create miniapps button section start -->
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="main-img" *ngIf="apiKeyIsGenerated && allMiniAppsDetails?.length == 0">
        <img src="../../assets/mesage-main.svg" />
        <label class="createBot-label" fxLayoutAlign="center center">Create and Add your Mini App to start your journey now</label>
        <!-- <a class="btn add btn-primary primary-button createMiniApps-btn" style="width:20vw" [routerLink]="['/miniappss/create-miniapps']">Create MiniApps</a> -->
        <button type="button"  fxLayoutAlign="center center" type="submit" class="btn add btn-primary createBot-btn" style="width: 18vw" fxFlex
        [routerLink]="'/miniapps/create-miniapps'">Create Mini App</button>
        <label class="terms-label">&nbsp;By clicking on Create now, you agree to the <a class="terms-conditions" (click)="goToLink('https://swiftchat.ai/securityandprivacy/swiftchat-bot-api-integration-terms/')">Terms & Conditions</a> of SwiftChat Mini App creation</label>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="main-img" *ngIf="!apiKeyIsGenerated">
        <img src="../../assets/mesage-main.svg" />
        <label class="createBot-label">Go to homepage to Generate Api Key and create new miniappss</label>
        <!-- <a class="btn add btn-primary primary-button homePage-btn" style="width:20vw" [routerLink]="['../insights']">Go to Homepage</a> -->
        <button type="button"  fxLayoutAlign="center center" type="submit" class="btn add btn-primary homePage-btn" style="width: 18vw" fxFlex
        [routerLink]="['../insights']">Go to Homepage</button>
    </div>
    <!-- create miniapps button section end -->
   
    <div fxLayout="row" class="px-4 py-3 res-px-2" #widgetsContent style="overflow-x: auto;overflow: hidden;scroll-behavior: smooth;width: 100%;" *ngIf="progressArray.length > 2" >
        <ng-container *ngFor="let element of allMiniAppsConfigurationDetails" >
            <div  fxLayout="row" fxLayoutAlign="space-between center" class="progress-section mx-2" 
            *ngIf="element?.progress !== 100" style="min-width:max-content;" #widgetsContentItem>
                <div  fxLayout="column">
                    <div class="basic-container" ><svg  style="position: absolute;" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.08" cx="21" cy="21" r="21" fill="#386AF6"/>
                        </svg>
                        <mat-progress-spinner strokeWidth="2.5" [diameter]="42"  mode="determinate"
                        [value]="element?.progress"></mat-progress-spinner>
                        <img src="assets/bots-image-insights.svg"  class="progress-img"/>
                </div>
                </div>
                <div fxLayout="column" class="dis-block px-3">
                    <div fxLayout="row">
                        <label class="onboarding-label">Onboarding for {{element?.name}}</label>
                    </div>
                    <div fxLayout="row">
                        <label class="percentage-label"> {{element?.progress}}% Completed</label>
                        <div class="divider"></div>
                        <a (click)="completeNow(element.mini_app_uuid,element.progress)" class="complete-btn">
                            Complete Now
                        </a>
                    </div>
                </div>
            </div>
        
        </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" *ngIf="progressArray.length > 2">
        <mat-icon (click)="scrollLeft();onClick(1)" [ngStyle]="tab =='tab1'? {'color': '#386AF6'}:{'color': '#999999'}" class="scroll-icon" >chevron_left</mat-icon>
        <mat-icon  style="color:#BEBEBE ; cursor: pointer;">more_horiz</mat-icon >
        <mat-icon (click)="scrollRight();onClick(2)"  [ngStyle]="tab =='tab2'? {'color': '#386AF6'}:{'color': '#999999'}"  class="scroll-icon" >chevron_right</mat-icon>
    </div>

    <div fxLayout="row" #widgetsContent class="bot2-section" *ngIf="progressArray.length == 2">
        <ng-container *ngFor="let element of allMiniAppsConfigurationDetails" >
            <div  fxLayout="row" fxLayoutAlign="space-between center" class="progress-bot-section" 
            *ngIf="element?.progress !== 100" style="min-width: 35%;">
                <div  fxLayout="column">
                    <div class="basic-container" ><svg  style="position: absolute;" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.08" cx="21" cy="21" r="21" fill="#386AF6"/>
                        </svg>
                        <mat-progress-spinner strokeWidth="2.5" [diameter]="42"  mode="determinate"
                        [value]="element?.progress"></mat-progress-spinner>
                        <img src="assets/bots-image-insights.svg"  class="progress-img"/>
                </div>
                </div>
                <div fxLayout="row" fxFlex="90" fxLayoutAlign="space-between center" class="dis-block">
                    <div fxLayout="row">
                        <label class="onboarding-label">Onboarding for {{element?.name}}</label>
                    </div>
                         <div fxLayout="row" >
                            <label class="percentage-label"> {{element?.progress}}% Completed</label>
                            <div class="divider"></div>
                            <a (click)="completeNow(element.mini_app_uuid,element.progress)" class="complete-btn">
                                Complete Now
                            </a>
                        </div>
                    </div>
            </div>
        
        </ng-container>
    </div>

    <div fxLayout="row" #widgetsContent class="bot1-section px-4 sm-paddingX-1 sm-paddingB-2 sm-paddingT-1"  *ngIf="progressArray.length == 1" >
        <ng-container *ngFor="let element of allMiniAppsConfigurationDetails">
            <div  fxLayout="row"  class="bot-progress" 
            *ngIf="element?.progress !== 100"  fxLayoutGap="15px">
                <div  fxLayout="column">
                    <div class="basic-container" ><svg  style="position: absolute;" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle opacity="0.08" cx="21" cy="21" r="21" fill="#386AF6"/>
                        </svg>
                        <mat-progress-spinner strokeWidth="2.5" [diameter]="42"  mode="determinate"
                        [value]="element?.progress"></mat-progress-spinner>
                        <img src="assets/bot-image-insights.svg"  class="progress-img"/>
                </div>
                </div>
                <div fxLayout="row" fxFlex="90" fxLayoutAlign="space-between center" class="dis-block">
                <div fxLayout="row">
                    <label class="onboarding-label">Onboarding for {{element?.name}}</label>
                </div>
                     <div fxLayout="row" >
                        <label class="percentage-label"> {{element?.progress}}% Completed</label>
                        <div class="divider"></div>
                        <a (click)="completeNow(element.mini_app_uuid,element.progress)" class="complete-btn">
                            Complete Now
                        </a>
                    </div>
                </div>
            </div>
        
        </ng-container>
    </div>


    <div class="hidden-sm pt-4 pb-2" fxLayout="row"  fxLayoutAlign="start center" *ngIf="allMiniAppsDetails?.length > 0">
        <div fxFlex="32" fxFlexOffset="3%" class="bot-header">Mini App Name</div>
        <div fxFlex="24" class="bot-header">Phone No.</div>
        <div fxFlex="16" class="bot-header">Status</div>
        <div  fxFlex="17"  class="bot-header">Mini App Link</div>
        
        <!-- <div  fxFlex="25"  class="miniapps-header">Total Conversations</div> -->

    </div>
    <div class="bot-list-section hidden-sm" fxLayout="column" fxLayoutAlign="start start"  *ngIf="allMiniAppsDetails?.length > 0">
        <div  fxFlex="16" class="bot-section" fxLayoutAlign="start center"
            *ngFor="let miniapps of allMiniAppsDetails; let i=index;" style="margin-bottom:10px;width: 99%;">
            <div fxFlex="28" fxLayoutAlign="start center">
                <div fxFlex="19" fxLayout="column">
                    <img *ngIf="allMiniAppsConfigurationDetails[i]?.photo" [src]="allMiniAppsConfigurationDetails[i]?.photo"
                        width="40" height="40" style="margin-right:30px" />
                </div>
                <div class="bot-list">{{miniapps.name}}</div>
            </div>
            <div fxFlex="7" class="divider"></div>
            <div *ngIf="miniapps.mobile === null " fxFlex="17" class="bot-list">{{miniapps.email}}</div>
            <div *ngIf="miniapps.email === null " fxFlex="17" class="bot-list">{{miniapps.mobile}}</div>
            <div  fxFlex="9"  class="divider"></div>
            <div fxFlex="13" fxLayout="row" *ngIf="miniapps.status=='ACTIVE'">
                <div>
                    <div class="active-label">
                        <label>Active</label>
                    </div>
                </div>
            </div>
            <div fxFlex="13" fxLayout="row"  *ngIf="miniapps.status=='INACTIVE'">
                <div >
                    <div class="inactive-label">
                        <label>Inactive</label>
                    </div>
                </div>
             </div>
             <div  fxFlex="4"  class="divider"></div>
             <div fxFlex="17">
                <button tooltip="Copied to clipboard"  (mouseleave)="toolTip.hide()" triggers="" #toolTip="bs-tooltip"   placement="bottom" type="button" [matRippleCentered]="true" matRipple   class="copybot-btn" ngxClipboard (click)="toolTip.show()" [cbContent]="allMiniAppsShareableLinks[i]"> Copy Link <mat-icon style="font-size: 13px;">
                    content_copy
                </mat-icon></button>
            </div>
            <div fxFlex="5" fxLayoutAlign="end center" (click)="goToEditMiniApps(miniapps.mini_app_id)">
                <button type="button"    fxLayoutAlign="center center"class="next-btn" mat-mini-fab>
                    <mat-icon>
                        <span class="material-symbols-outlined">
                            chevron_right
                        </span>
                    </mat-icon>
                </button>
            </div>

            <!-- <div  fxFlex="25" >{{miniapps.status}}</div>
        <div  fxFlex="25" >Total Conversations</div> -->
        </div>

    </div>
    <div *ngIf="allMiniAppsDetails?.length > 0" class="hidden-xl pb-3">
        <div class="px-3 pt-3" *ngFor="let miniapps of allMiniAppsDetails; let i=index;">
            <div class="hidden-xl card">
                <div class="container">
                    <div class="row px-2 pt-4 pb-3" style="border: 1px solid #ECECEC;">
                        <div class="d-flex" fxLayoutAlign="space-between center">
                            <div class="d-flex">
                                <img *ngIf="allMiniAppsConfigurationDetails[i]?.photo" [src]="allMiniAppsConfigurationDetails[i]?.photo"
                                    width="50" height="50" />
                                <div>
                                    <div class="bot-list px-2">{{miniapps.name}}</div>
                                    <button tooltip="Copied to clipboard" (mouseleave)="toolTip.hide()" triggers="" #toolTip="bs-tooltip"   placement="bottom" type="button" [matRippleCentered]="true" matRipple   class="copybot-btn" ngxClipboard (click)="toolTip.show()" [cbContent]="allMiniAppsShareableLinks[i]"> Copy Link 
                                        <mat-icon style="font-size: 13px;">content_copy</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div (click)="goToEditMiniApps(miniapps.mini_app_id)">
                                <button type="button" class="next-btn" mat-mini-fab style="padding: 1.5px 2px !important;">
                                    <mat-icon>
                                        <span class="material-symbols-outlined">
                                            chevron_right
                                        </span>
                                    </mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row px-2 py-3">
                        <div>
                            <div class="pull-left">
                                <div class="bot-header">Phone No.</div>
                                <div class="bot-list">{{miniapps.mobile}}</div>
                            </div>
                            <div class="pull-right">
                                <div class="bot-header">Status</div>
                                <div *ngIf="miniapps.status=='ACTIVE'">
                                    <div>
                                        <div class="active-label">
                                            <label>Active</label>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="miniapps.status=='INACTIVE'">
                                    <div>
                                        <div class="inactive-label">
                                            <label>Inactive</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>